import React from 'react';

export default ({ classes }) => [
  {
    children: [
      {
        children: [
          {
            labelText: 'Font',
            name: 'typography.h1.fontFamily',
            placeholder: 'Paste the web font URL',
            tooltip: (
              <div className={classes.tooltip}>
                Copy the web font URL and paste it in the designated typography fields.
              </div>
            ),
            type: 'fontFamily',
            urlName: 'typography.fontFamilies.urls'
          },
          {
            backgroundColor: 'palette.background',
            fontSize: 'typography.h1.fontSize',
            fontWeight: 'typography.h1.fontWeight',
            labelText: 'Color',
            name: 'typography.h1.color'
          },
          { labelText: 'Weight', name: 'typography.h1.fontWeight', type: 'fontWeight' }
        ],
        labelText: 'Header 1',
        name: 'typography.h1'
      },
      {
        children: [
          {
            labelText: 'Font',
            name: 'typography.h2.fontFamily',
            placeholder: 'Paste the web font URL',
            tooltip: (
              <div className={classes.tooltip}>
                Copy the web font URL and paste it in the designated typography fields.
              </div>
            ),
            type: 'fontFamily',
            urlName: 'typography.fontFamilies.urls'
          },
          {
            backgroundColor: 'palette.background',
            fontSize: 'typography.h2.fontSize',
            fontWeight: 'typography.h2.fontWeight',
            labelText: 'Color',
            name: 'typography.h2.color'
          },
          { labelText: 'Weight', name: 'typography.h2.fontWeight', type: 'fontWeight' }
        ],
        labelText: 'Header 2',
        name: 'typography.h2'
      },
      {
        children: [
          {
            labelText: 'Font',
            name: 'typography.h3.fontFamily',
            placeholder: 'Paste the web font URL',
            tooltip: (
              <div className={classes.tooltip}>
                Copy the web font URL and paste it in the designated typography fields.
              </div>
            ),
            type: 'fontFamily',
            urlName: 'typography.fontFamilies.urls'
          },
          {
            backgroundColor: 'palette.background',
            fontSize: 'typography.h3.fontSize',
            fontWeight: 'typography.h3.fontWeight',
            labelText: 'Color',
            name: 'typography.h3.color'
          },
          { labelText: 'Weight', name: 'typography.h3.fontWeight', type: 'fontWeight' }
        ],
        labelText: 'Header 3',
        name: 'typography.h3'
      },
      {
        children: [
          {
            labelText: 'Font',
            name: 'typography.h4.fontFamily',
            placeholder: 'Paste the web font URL',
            tooltip: (
              <div className={classes.tooltip}>
                Copy the web font URL and paste it in the designated typography fields.
              </div>
            ),
            type: 'fontFamily',
            urlName: 'typography.fontFamilies.urls'
          },
          {
            backgroundColor: 'palette.background',
            fontSize: 'typography.h4.fontSize',
            fontWeight: 'typography.h4.fontWeight',
            labelText: 'Color',
            name: 'typography.h4.color'
          },
          { labelText: 'Weight', name: 'typography.h4.fontWeight', type: 'fontWeight' }
        ],
        labelText: 'Header 4',
        name: 'typography.h4'
      },
      {
        labelText: 'Paragraph Font',
        name: 'typography.p.fontFamily',
        placeholder: 'Paste the web font URL',
        tooltip: (
          <div className={classes.tooltip}>
            Copy the web font URL and paste it in the designated typography fields.
          </div>
        ),
        type: 'fontFamily',
        urlName: 'typography.fontFamilies.urls'
      },
      {
        children: [
          {
            backgroundColor: 'palette.background',
            fontSize: 'typography.p1.fontSize',
            fontWeight: 'typography.p1.fontWeight',
            labelText: 'Color',
            name: 'typography.p1.color'
          },
          { labelText: 'Weight', name: 'typography.p1.fontWeight', type: 'fontWeight' }
        ],
        labelText: 'Paragraph 1',
        name: 'typography.p1'
      },
      {
        children: [
          {
            backgroundColor: 'palette.background',
            fontSize: 'typography.p2.fontSize',
            fontWeight: 'typography.p2.fontWeight',
            labelText: 'Color',
            name: 'typography.p2.color'
          },
          { labelText: 'Weight', name: 'typography.p2.fontWeight', type: 'fontWeight' }
        ],
        labelText: 'Paragraph 2',
        name: 'typography.p2'
      },
      {
        children: [
          {
            backgroundColor: 'palette.background',
            fontSize: 'typography.p3.fontSize',
            fontWeight: 'typography.p3.fontWeight',
            labelText: 'Color',
            name: 'typography.p3.color'
          },
          { labelText: 'Weight', name: 'typography.p3.fontWeight', type: 'fontWeight' }
        ],
        labelText: 'Paragraph 3',
        name: 'typography.p3'
      },
      {
        labelText: 'Error',
        name: 'palette.error'
      }
    ],
    labelText: 'Typography',
    name: 'typography'
  },
  {
    children: [
      {
        exclude: true,
        labelText: 'Logo',
        name: 'logo',
        placeholder: 'Paste the logo image address',
        tooltip: (
          <div className={classes.tooltip}>
            To temporarily display your logo, copy the logo’s image address from a browser and
            paste it in the designated logo field. Bottomline requires the source logo file be
            sent via email, for final implementation.
          </div>
        ),
        type: 'string'
      },
      { labelText: 'Background Color', name: 'palette.progress.background', type: 'colorWithGradient' },
      {
        children: [
          {
            labelText: 'Font',
            name: 'typography.progress.fontFamily',
            placeholder: 'Paste the web font URL',
            tooltip: (
              <div className={classes.tooltip}>
                Copy the web font URL and paste it in the designated typography fields.
              </div>
            ),
            type: 'fontFamily',
            urlName: 'typography.fontFamilies.urls'
          },
          {
            backgroundColor: 'palette.progress.background',
            labelText: 'Completed Color',
            name: 'palette.progress.complete'
          },
          {
            backgroundColor: 'palette.progress.background',
            labelText: 'Incomplete Color',
            name: 'palette.progress.inComplete'
          },
          {
            backgroundColor: 'palette.progress.background',
            fontSize: 'typography.progress.fontSize',
            fontWeight: 'typography.progress.fontWeight',
            labelText: 'Text Color',
            name: 'typography.progress.color'
          }
        ],
        labelText: 'Progress Meter',
        name: 'progressMeter'
      }
    ],
    labelText: 'Header',
    name: 'header'
  },
  {
    children: [
      {
        backgroundColor: 'palette.background',
        fontSize: 'forms.label.fontSizeNormal',
        fontWeight: 'typography.fontWeights.regular',
        labelText: 'Idle Label Color',
        name: 'palette.form.placeholder'
      },
      {
        backgroundColor: 'palette.background',
        fontSize: 'forms.label.fontSizeFocused',
        fontWeight: 'typography.fontWeights.regular',
        labelText: 'Active Label Color',
        name: 'palette.form.active'
      }
    ],
    labelText: 'Form Fields',
    name: 'formFields'
  },
  {
    children: [
      {
        children: [
          {
            labelText: 'Corner Radius',
            name: 'oaoButtons.primary.borderRadius',
            type: 'pixel'
          },
          { labelText: 'Idle Background Color', name: 'oaoButtons.primary.background', type: 'colorWithGradient' },
          { labelText: 'Idle Border Color', name: 'oaoButtons.primary.borderColor' },
          { labelText: 'Hover Background Color', name: 'oaoButtons.primary.hoverBackground', type: 'colorWithGradient' },
          { labelText: 'Hover Border Color', name: 'oaoButtons.primary.hoverBorderColor' },
          {
            labelText: 'Font',
            name: 'oaoButtons.primary.fontFamily',
            type: 'fontFamily',
            urlName: 'typography.fontFamilies.urls'
          },
          {
            labelText: 'Font Weight',
            name: 'oaoButtons.primary.fontWeight',
            type: 'fontWeight'
          },
          {
            backgroundColor: 'oaoButtons.primary.background',
            fontSize: 'oaoButtons.primary.fontSize',
            fontWeight: 'oaoButtons.primary.fontWeight',
            labelText: 'Idle Text Color',
            name: 'oaoButtons.primary.color'
          },
          {
            backgroundColor: 'oaoButtons.primary.hoverBackground',
            fontSize: 'oaoButtons.primary.fontSize',
            fontWeight: 'oaoButtons.primary.fontWeight',
            labelText: 'Hover Text Color',
            name: 'oaoButtons.primary.hoverColor'
          }
        ],
        labelText: 'Primary',
        name: 'oaoButtons.primary'
      },
      {
        children: [
          {
            labelText: 'Corner Radius',
            name: 'oaoButtons.secondary.borderRadius',
            type: 'pixel'
          },
          { labelText: 'Idle Background Color', name: 'oaoButtons.secondary.background', type: 'colorWithGradient' },
          { labelText: 'Idle Border Color', name: 'oaoButtons.secondary.borderColor' },
          { labelText: 'Hover Background Color', name: 'oaoButtons.secondary.hoverBackground', type: 'colorWithGradient' },
          { labelText: 'Hover Border Color', name: 'oaoButtons.secondary.hoverBorderColor' },
          {
            labelText: 'Font',
            name: 'oaoButtons.secondary.fontFamily',
            type: 'fontFamily',
            urlName: 'typography.fontFamilies.urls'
          },
          {
            labelText: 'Font Weight',
            name: 'oaoButtons.secondary.fontWeight',
            type: 'fontWeight'
          },
          {
            backgroundColor: 'oaoButtons.secondary.background',
            fontSize: 'oaoButtons.secondary.fontSize',
            fontWeight: 'oaoButtons.secondary.fontWeight',
            labelText: 'Idle Text Color',
            name: 'oaoButtons.secondary.color'
          },
          {
            backgroundColor: 'oaoButtons.secondary.hoverBackground',
            fontSize: 'oaoButtons.secondary.fontSize',
            fontWeight: 'oaoButtons.secondary.fontWeight',
            labelText: 'Hover Text Color',
            name: 'oaoButtons.secondary.hoverColor'
          }
        ],
        labelText: 'Secondary',
        name: 'oaoButtons.secondary'
      }
    ],
    labelText: 'Buttons',
    name: 'buttons'
  },
  {
    children: [
      {
        labelText: 'Font',
        name: 'tabs.fontFamily',
        placeholder: 'Paste the web font URL',
        tooltip: (
          <div className={classes.tooltip}>
            Copy the web font URL and paste it in the designated typography fields.
          </div>
        ),
        type: 'fontFamily',
        urlName: 'typography.fontFamilies.urls'
      },
      { labelText: 'Font Weight', name: 'tabs.fontWeight', type: 'fontWeight' },
      { labelText: 'Active Color', name: 'tabs.activeColor' },
      { labelText: 'Idle Color', name: 'tabs.color' },
      { labelText: 'Hover Color', name: 'tabs.hoverColor' }
    ],
    labelText: 'Tabs',
    name: 'tabs'
  },
  {
    children: [
      { backgroundColor: 'palette.background', labelText: 'Color', name: 'palette.icon' }
    ],
    labelText: 'Icons',
    name: 'icons'
  },
  {
    children: [
      {
        backgroundColor: 'palette.background',
        labelText: 'Idle Color',
        name: 'links.link.color'
      },
      {
        backgroundColor: 'palette.background',
        labelText: 'Hover Color',
        name: 'links.link.hoverColor'
      },
      {
        children: [
          {
            labelText: 'Font',
            name: 'actions.callToAction.fontFamily',
            placeholder: 'Paste the web font URL',
            tooltip: (
              <div className={classes.tooltip}>
                Copy the web font URL and paste it in the designated typography fields.
              </div>
            ),
            type: 'fontFamily',
            urlName: 'typography.fontFamilies.urls'
          }
        ],
        labelText: 'Call to Action',
        name: 'actions.callToAction'
      }
    ],
    labelText: 'Links',
    name: 'links'
  }
];
